/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ticket_received_explainer = () => `Een ticket kan één keer worden doorgegeven, dus dit ticket kun je niet opnieuw delen. Is het niet voor jou? Geef het dan terug aan degene die het met je deelde — die kan het daarna aan de juiste persoon geven.`
